<template lang="pug">
  v-row.px-2
    v-col(cols="12")
      h1 Задания для прохождения
    v-col(cols="12")
      v-slide-y-reverse-transition(mode="out-in")
        div(v-if="loading" class="text-center pt-5")
          sdo-loader

      v-card(
        v-for="courseUnit in course.course_units"
        :courseUnit="courseUnit.id"
        class="sdo-card mb-5"
        :key="courseUnit.id"
      )
        v-card-title.ml-4.mt-2 {{ courseUnit.title }}
        v-divider.mx-4
        v-card-text
          v-expansion-panels(class="mb-4" accordion flat multiple)
            v-expansion-panel(
              v-if="courseUnit.lessons.length"
              v-for="lesson in courseUnit.lessons" :key="lesson.id"
            )
              v-expansion-panel-header {{ lesson.name }}
              v-expansion-panel-content
                task-table(
                  v-if="lesson.tasks_user.length"
                  :items="lesson.tasks_user"
                )
                p(v-else class="pa-2 pb-0 grey--text") Нет заданий
            v-expansion-panel(v-if="courseUnit.tasks_user.length" key="exam")
              v-expansion-panel-header Задания к теме
              v-expansion-panel-content
                task-table(
                  v-if="courseUnit.tasks_user.length"
                  :items="courseUnit.tasks_user"
                )
                p(v-else class="pa-2 pb-0 grey--text") Нет заданий
          p(
            v-if="courseUnit && !courseUnit.lessons.length && !courseUnit.tasks_user.length"
            class="pa-2 pb-0 grey--text"
          ) Нет заданий

      v-card(
        v-if="course.tasks_user && course.tasks_user.length"
        class="sdo-card mb-5"
        key="last"
      )
        v-card-title.ml-4.mt-2 Контрольная работа
        v-divider.mx-4
        v-card-text
          task-table(
            v-if="course.tasks_user.length"
            :items="course.tasks_user"
          )

</template>

<script>
import anime from 'animejs';

import TaskService from '@/services/API/TaskService';
import TaskTable from '@/modules/Education/Tasks/components/TaskTable.vue';

export default {
  name: 'TaskListForPass',
  components: { TaskTable },
  data: () => ({
    loading: false,
    course: {},
    units: [],
  }),
  mounted() {
    this.getCourse();
  },
  methods: {
    getCourse() {
      this.loading = true;
      this.$rHandler(
        // CourseService.getCourse(this.group.course.id),
        TaskService.getTaskListForUser(this.$route.params.groupId),
        (r) => {
          this.course = r.data.data;
          this.course.course_units.forEach((u, i) => this.units.push(i));
          this.loading = false;
          setTimeout(() => {
            anime({
              targets: '.sdo-card',
              translateY: [100, 0],
              opacity: [0, 1],
              duration: 600,
              autoplay: true,
              easing: 'easeOutExpo',
              delay: anime.stagger(100),
            });
          }, 600);
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sdo-card {
  opacity: 0;
  background: map-get($grey, 'lighten-4');
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
  0 2px 2px 0px rgba(0, 0, 0, 0.14),
  0 1px 5px 0px rgba(0, 0, 0, 0.12) !important;

  &.theme--dark {
    background: $layout-dark-bg;
  }
}

.theme--light.v-expansion-panels .v-expansion-panel,
.theme--dark.v-expansion-panels .v-expansion-panel {
  background: none;
}

.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 0;
}
</style>
